// Super Admin → Site (`super_admin/site/`): the marketing landing page's content, media
// library and navigation links (docs/hq-site-module/hq-site-api-contract.md), plus the
// media-library image slots it lends to the HQ blog, plan and booster editors.
//
// Error sentences (`hsite.err.*`) are the contract §4 codes, one each; their `{vars}` are
// the refusal's structured extras (super_admin/site/siteErrors.js).
export default {
  fr: {
    "hsite.title": "Site Solunary",
    "hsite.subtitle": "Tout ce que dit, montre et relie la page d'accueil publique. Chaque enregistrement est en ligne immédiatement.",
    "hsite.tab.content": "Contenu",
    "hsite.tab.media": "Médias",
    "hsite.tab.links": "Liens",
    "hsite.retry": "Réessayer",

    "hsite.section.navbar": "En-tête",
    "hsite.section.hero": "Hero",
    "hsite.section.dualpillar": "Deux piliers",
    "hsite.section.ecosystem": "Écosystème",
    "hsite.section.pricing": "Tarifs",
    "hsite.section.turnkey": "Clé en main & reprise",
    "hsite.section.boosters": "Boosters & frais",
    "hsite.section.faq": "FAQ",
    "hsite.section.finalCta": "Appel final",
    "hsite.section.footer": "Pied de page",
    "hsite.locale.fr": "Français",
    "hsite.locale.en": "Anglais",
    "hsite.locale.es": "Espagnol",

    "hsite.content.hint": "Laissez une langue vide pour garder le texte par défaut (affiché en gris). Une modification dans une langue ne s'affiche qu'aux visiteurs de cette langue.",
    "hsite.content.sections": "Sections de la page",
    "hsite.content.vars": "Variables :",
    "hsite.content.overridden": "Modifié",
    "hsite.content.default": "Par défaut",
    "hsite.content.save": "Enregistrer",
    "hsite.content.saved": "Enregistré — en ligne",
    "hsite.content.reset": "Rétablir le défaut",
    "hsite.content.resetDone": "Texte par défaut rétabli",
    "hsite.content.tooLong": "{locale} : {max} caractères au maximum.",
    "hsite.content.undeclared": "{locale} : {placeholders} n'est pas une variable de ce champ.",
    "hsite.content.imageDefault": "Image par défaut du site",
    "hsite.content.imageChosen": "Image choisie dans la médiathèque",

    "hsite.media.hint": "Les images de la page d'accueil, du blog, des plans et des boosters. Une image utilisée ne peut pas être supprimée.",
    "hsite.media.upload": "Téléverser une image",
    "hsite.media.uploading": "Téléversement…",
    "hsite.media.uploaded": "Image ajoutée",
    "hsite.media.rules": "{types} · {max} au maximum",
    "hsite.media.wrongType": "Format refusé. Formats acceptés : {types}.",
    "hsite.media.tooBig": "Fichier trop lourd : {max} au maximum.",
    "hsite.media.empty": "Aucune image pour l'instant.",
    "hsite.media.alt": "Texte alternatif {locale}",
    "hsite.media.altTooLong": "Texte alternatif : {max} caractères au maximum.",
    "hsite.media.saveAlt": "Enregistrer",
    "hsite.media.altSaved": "Texte alternatif enregistré",
    "hsite.media.usage": "Utilisations",
    "hsite.media.unused": "Utilisée nulle part.",
    "hsite.media.delete": "Supprimer",
    "hsite.media.confirmDelete": "Confirmer la suppression",
    "hsite.media.deleted": "Image supprimée",
    "hsite.media.ref.content_block": "Page d'accueil",
    "hsite.media.ref.blog_post": "Article de blog",
    "hsite.media.ref.plan": "Plan",
    "hsite.media.ref.booster": "Booster",

    "hsite.picker.title": "Médiathèque",
    "hsite.picker.description": "Choisissez une image, ou téléversez-en une nouvelle.",
    "hsite.picker.empty": "La médiathèque est vide — téléversez une image.",
    "hsite.picker.choose": "Choisir {name}",
    "hsite.picker.chooseImage": "Choisir une image",
    "hsite.picker.replace": "Remplacer",
    "hsite.picker.remove": "Retirer l'image",

    "hsite.links.hint": "L'en-tête et le pied de page du site affichent exactement ces liens, dans cet ordre. Un groupe de pied de page vide n'est pas affiché.",
    "hsite.links.header": "En-tête",
    "hsite.links.footer": "Pied de page",
    "hsite.links.footerGroup": "Pied de page — {group}",
    "hsite.links.group.product": "Produit",
    "hsite.links.group.company": "Entreprise",
    "hsite.links.group.legal": "Légal",
    "hsite.links.add": "Ajouter un lien",
    "hsite.links.empty": "Aucun lien.",
    "hsite.links.label": "Libellé {locale}",
    "hsite.links.hrefLabel": "Destination",
    "hsite.links.hrefPlaceholder": "#pricing, /marketplace, https://…, mailto:…",
    "hsite.links.href.help": "Une section de la page (#…), une page du site (/…), une adresse https:// ou mailto:.",
    "hsite.links.href.tooLong": "{max} caractères au maximum.",
    "hsite.links.href.unknownAnchor": "Cette section n'existe pas sur la page. Sections : {anchors}.",
    "hsite.links.href.invalid": "Destination refusée : utilisez #section, /page, https://… ou mailto:….",
    "hsite.links.newTab": "Ouvrir dans un nouvel onglet",
    "hsite.links.location": "Emplacement",
    "hsite.links.groupLabel": "Groupe",
    "hsite.links.save": "Enregistrer",
    "hsite.links.cancel": "Annuler",
    "hsite.links.created": "Lien ajouté",
    "hsite.links.updated": "Lien modifié",
    "hsite.links.deleted": "Lien supprimé",
    "hsite.links.edit": "Modifier {label}",
    "hsite.links.delete": "Supprimer {label}",
    "hsite.links.confirmDelete": "Confirmer la suppression de {label}",
    "hsite.links.confirmDeleteShort": "Confirmer",
    "hsite.links.moveUp": "Monter {label}",
    "hsite.links.moveDown": "Descendre {label}",

    "hsite.err.generic": "L'enregistrement a échoué. Réessayez.",
    "hsite.err.unknownKey": "Le champ {key} n'existe plus. Rechargez la page.",
    "hsite.err.wrongKind": "Le champ {key} n'accepte pas ce type de contenu.",
    "hsite.err.undeclaredPlaceholder": "{locale} : {placeholders} n'est pas une variable de ce champ. Variables autorisées : {allowed}.",
    "hsite.err.noPlaceholderAllowed": "aucune",
    "hsite.err.tooLong": "{locale} : {max} caractères au maximum.",
    "hsite.err.unknownMedia": "Cette image n'est plus dans la médiathèque. Choisissez-en une autre.",
    "hsite.err.invalidHref": "Destination refusée : {href}",
    "hsite.err.invalidLinkGroup": "Choisissez un groupe pour un lien de pied de page (et aucun pour l'en-tête).",
    "hsite.err.linkNotFound": "Ce lien n'existe plus. Rechargez la page.",
    "hsite.err.mediaNotFound": "Cette image n'existe plus. Rechargez la page.",
    "hsite.err.mediaInUse": "Image utilisée à {count} endroit(s) : retirez-la d'abord.",
    "hsite.err.unsupportedMediaType": "Ce fichier n'est pas une image acceptée (PNG, JPEG, WEBP ou GIF).",
    "hsite.err.mediaTooLarge": "Fichier trop lourd : {max} au maximum.",
    "hsite.err.mediaTooLargeNoMax": "Fichier trop lourd.",
    "hsite.err.reorderMismatch": "Les liens ont changé entre-temps. Rechargez la page puis réessayez.",

    "hqblog.title": "Blog",
    "hqblog.subtitle": "Les articles publiés sur le blog Solunary.",
    "hqblog.new": "Nouvel article",
    "hqblog.colTitle": "Titre",
    "hqblog.colLanguages": "Langues",
    "hqblog.colStatus": "Statut",
    "hqblog.colPublished": "Publié le",
    "hqblog.colUpdated": "Modifié le",
    "hqblog.published": "publié",
    "hqblog.draft": "brouillon",
    "hqblog.never": "—",
    "hqblog.empty": "Aucun article.",
    "hqblog.confirmDelete": "Supprimer cet article ?",
    "hqblog.saved": "Enregistré",
    "hqblog.error": "Erreur",
    "hqblog.retry": "Réessayer",
    "hqblog.editTitle": "Modifier l'article",
    "hqblog.newTitle": "Nouvel article",
    "hqblog.search": "Rechercher (titre ou slug)",
    "hqblog.filterStatus": "Filtrer par statut",
    "hqblog.statusAll": "Tous",
    "hqblog.statusPublished": "Publiés",
    "hqblog.statusDraft": "Brouillons",
    "hqblog.sortBy": "Trier par",
    "hqblog.sortUpdated": "Dernière modification",
    "hqblog.sortPublished": "Date de publication",
    "hqblog.sortCreated": "Date de création",
    "hqblog.total": "{total} article(s)",
    "hqblog.pagerInfo": "{from}–{to} sur {total}",
    "hqblog.pagerPrev": "Précédent",
    "hqblog.pagerNext": "Suivant",
    "hqblog.edit": "Modifier",
    "hqblog.preview": "Aperçu",
    "hqblog.openPublic": "Ouvrir la page publique",
    "hqblog.delete": "Supprimer",
    "hqblog.close": "Fermer",
    "hqblog.write": "Écrire",
    "hqblog.lang.fr": "Français",
    "hqblog.lang.en": "Anglais",
    "hqblog.lang.es": "Espagnol",
    "hqblog.fTitle": "Titre",
    "hqblog.fExcerpt": "Extrait",
    "hqblog.fTag": "Tag",
    "hqblog.fBody": "Contenu (Markdown)",
    "hqblog.fSlug": "Slug (adresse de l'article)",
    "hqblog.fPublished": "Publié",
    "hqblog.excerptHint": "Sert aussi de description lors du partage du lien.",
    "hqblog.bodyHint": "Markdown : # titre, **gras**, *italique*, [lien](https://…), listes avec - ou 1.",
    "hqblog.slugHint": "Lettres minuscules, chiffres et tirets. Proposé à partir du premier titre.",
    "hqblog.savecta": "Enregistrer",
    "hqblog.err.slugTaken": "Ce slug est déjà utilisé par un autre article.",
    "hqblog.err.noLanguage": "Remplissez au moins une langue (titre et contenu).",
    "hqblog.err.notFound": "Article introuvable.",
    // the per-field line of a FastAPI 422 list (lib/apiErrors.js asks for this key on the `t` it is given)
    "errors.invalidFieldValue": "Valeur invalide",
    "hqblog.err.languageIncomplete": "Langue {lang} : le titre et le contenu doivent tous deux être remplis, ou tous deux vides.",
    "hqblog.err.slugRequired": "Le slug est obligatoire.",
    "hqblog.cover": "Image de couverture",
    "plans.image": "Image du plan",
    "cat.boosterImage": "Image du booster",
  },
  en: {
    "hsite.title": "Solunary Site",
    "hsite.subtitle": "Everything the public landing page says, shows and links to. Every save is live at once.",
    "hsite.tab.content": "Content",
    "hsite.tab.media": "Media",
    "hsite.tab.links": "Links",
    "hsite.retry": "Retry",

    "hsite.section.navbar": "Header",
    "hsite.section.hero": "Hero",
    "hsite.section.dualpillar": "Two pillars",
    "hsite.section.ecosystem": "Ecosystem",
    "hsite.section.pricing": "Pricing",
    "hsite.section.turnkey": "Turnkey & porting",
    "hsite.section.boosters": "Boosters & fees",
    "hsite.section.faq": "FAQ",
    "hsite.section.finalCta": "Final call to action",
    "hsite.section.footer": "Footer",
    "hsite.locale.fr": "French",
    "hsite.locale.en": "English",
    "hsite.locale.es": "Spanish",

    "hsite.content.hint": "Leave a language empty to keep the default text (shown in grey). An edit in one language is shown only to visitors reading that language.",
    "hsite.content.sections": "Page sections",
    "hsite.content.vars": "Variables:",
    "hsite.content.overridden": "Edited",
    "hsite.content.default": "Default",
    "hsite.content.save": "Save",
    "hsite.content.saved": "Saved — live",
    "hsite.content.reset": "Restore default",
    "hsite.content.resetDone": "Default text restored",
    "hsite.content.tooLong": "{locale}: {max} characters at most.",
    "hsite.content.undeclared": "{locale}: {placeholders} is not a variable of this field.",
    "hsite.content.imageDefault": "The site's default image",
    "hsite.content.imageChosen": "Image chosen from the media library",

    "hsite.media.hint": "Images for the landing page, the blog, plans and boosters. An image in use cannot be deleted.",
    "hsite.media.upload": "Upload an image",
    "hsite.media.uploading": "Uploading…",
    "hsite.media.uploaded": "Image added",
    "hsite.media.rules": "{types} · {max} at most",
    "hsite.media.wrongType": "Format refused. Accepted formats: {types}.",
    "hsite.media.tooBig": "File too large: {max} at most.",
    "hsite.media.empty": "No images yet.",
    "hsite.media.alt": "Alt text {locale}",
    "hsite.media.altTooLong": "Alt text: {max} characters at most.",
    "hsite.media.saveAlt": "Save",
    "hsite.media.altSaved": "Alt text saved",
    "hsite.media.usage": "Where used",
    "hsite.media.unused": "Not used anywhere.",
    "hsite.media.delete": "Delete",
    "hsite.media.confirmDelete": "Confirm delete",
    "hsite.media.deleted": "Image deleted",
    "hsite.media.ref.content_block": "Landing page",
    "hsite.media.ref.blog_post": "Blog post",
    "hsite.media.ref.plan": "Plan",
    "hsite.media.ref.booster": "Booster",

    "hsite.picker.title": "Media library",
    "hsite.picker.description": "Choose an image, or upload a new one.",
    "hsite.picker.empty": "The media library is empty — upload an image.",
    "hsite.picker.choose": "Choose {name}",
    "hsite.picker.chooseImage": "Choose an image",
    "hsite.picker.replace": "Replace",
    "hsite.picker.remove": "Remove image",

    "hsite.links.hint": "The site's header and footer show exactly these links, in this order. An empty footer group is not shown.",
    "hsite.links.header": "Header",
    "hsite.links.footer": "Footer",
    "hsite.links.footerGroup": "Footer — {group}",
    "hsite.links.group.product": "Product",
    "hsite.links.group.company": "Company",
    "hsite.links.group.legal": "Legal",
    "hsite.links.add": "Add a link",
    "hsite.links.empty": "No links.",
    "hsite.links.label": "Label {locale}",
    "hsite.links.hrefLabel": "Destination",
    "hsite.links.hrefPlaceholder": "#pricing, /marketplace, https://…, mailto:…",
    "hsite.links.href.help": "A section of the page (#…), a page of the site (/…), an https:// or mailto: address.",
    "hsite.links.href.tooLong": "{max} characters at most.",
    "hsite.links.href.unknownAnchor": "That section does not exist on the page. Sections: {anchors}.",
    "hsite.links.href.invalid": "Destination refused: use #section, /page, https://… or mailto:….",
    "hsite.links.newTab": "Open in a new tab",
    "hsite.links.location": "Location",
    "hsite.links.groupLabel": "Group",
    "hsite.links.save": "Save",
    "hsite.links.cancel": "Cancel",
    "hsite.links.created": "Link added",
    "hsite.links.updated": "Link updated",
    "hsite.links.deleted": "Link deleted",
    "hsite.links.edit": "Edit {label}",
    "hsite.links.delete": "Delete {label}",
    "hsite.links.confirmDelete": "Confirm deleting {label}",
    "hsite.links.confirmDeleteShort": "Confirm",
    "hsite.links.moveUp": "Move {label} up",
    "hsite.links.moveDown": "Move {label} down",

    "hsite.err.generic": "The save failed. Try again.",
    "hsite.err.unknownKey": "The field {key} no longer exists. Reload the page.",
    "hsite.err.wrongKind": "The field {key} does not accept this kind of content.",
    "hsite.err.undeclaredPlaceholder": "{locale}: {placeholders} is not a variable of this field. Allowed variables: {allowed}.",
    "hsite.err.noPlaceholderAllowed": "none",
    "hsite.err.tooLong": "{locale}: {max} characters at most.",
    "hsite.err.unknownMedia": "That image is no longer in the media library. Choose another one.",
    "hsite.err.invalidHref": "Destination refused: {href}",
    "hsite.err.invalidLinkGroup": "Choose a group for a footer link (and none for a header link).",
    "hsite.err.linkNotFound": "That link no longer exists. Reload the page.",
    "hsite.err.mediaNotFound": "That image no longer exists. Reload the page.",
    "hsite.err.mediaInUse": "Image used in {count} place(s): remove it there first.",
    "hsite.err.unsupportedMediaType": "This file is not an accepted image (PNG, JPEG, WEBP or GIF).",
    "hsite.err.mediaTooLarge": "File too large: {max} at most.",
    "hsite.err.mediaTooLargeNoMax": "File too large.",
    "hsite.err.reorderMismatch": "The links changed in the meantime. Reload the page and try again.",

    "hqblog.title": "Blog",
    "hqblog.subtitle": "Articles published on the Solunary blog.",
    "hqblog.new": "New article",
    "hqblog.colTitle": "Title",
    "hqblog.colLanguages": "Languages",
    "hqblog.colStatus": "Status",
    "hqblog.colPublished": "Published",
    "hqblog.colUpdated": "Updated",
    "hqblog.published": "published",
    "hqblog.draft": "draft",
    "hqblog.never": "—",
    "hqblog.empty": "No articles.",
    "hqblog.confirmDelete": "Delete this article?",
    "hqblog.saved": "Saved",
    "hqblog.error": "Error",
    "hqblog.retry": "Retry",
    "hqblog.editTitle": "Edit article",
    "hqblog.newTitle": "New article",
    "hqblog.search": "Search (title or slug)",
    "hqblog.filterStatus": "Filter by status",
    "hqblog.statusAll": "All",
    "hqblog.statusPublished": "Published",
    "hqblog.statusDraft": "Drafts",
    "hqblog.sortBy": "Sort by",
    "hqblog.sortUpdated": "Last updated",
    "hqblog.sortPublished": "Publication date",
    "hqblog.sortCreated": "Creation date",
    "hqblog.total": "{total} article(s)",
    "hqblog.pagerInfo": "{from}–{to} of {total}",
    "hqblog.pagerPrev": "Previous",
    "hqblog.pagerNext": "Next",
    "hqblog.edit": "Edit",
    "hqblog.preview": "Preview",
    "hqblog.openPublic": "Open public page",
    "hqblog.delete": "Delete",
    "hqblog.close": "Close",
    "hqblog.write": "Write",
    "hqblog.lang.fr": "French",
    "hqblog.lang.en": "English",
    "hqblog.lang.es": "Spanish",
    "hqblog.fTitle": "Title",
    "hqblog.fExcerpt": "Excerpt",
    "hqblog.fTag": "Tag",
    "hqblog.fBody": "Body (Markdown)",
    "hqblog.fSlug": "Slug (article address)",
    "hqblog.fPublished": "Published",
    "hqblog.excerptHint": "Also used as the description when the link is shared.",
    "hqblog.bodyHint": "Markdown: # heading, **bold**, *italic*, [link](https://…), lists with - or 1.",
    "hqblog.slugHint": "Lowercase letters, digits and hyphens. Suggested from the first title.",
    "hqblog.savecta": "Save",
    "hqblog.err.slugTaken": "This slug is already used by another article.",
    "hqblog.err.noLanguage": "Fill in at least one language (title and body).",
    "hqblog.err.notFound": "Article not found.",
    // the per-field line of a FastAPI 422 list (lib/apiErrors.js asks for this key on the `t` it is given)
    "errors.invalidFieldValue": "Invalid value",
    "hqblog.err.languageIncomplete": "{lang}: the title and the body must both be filled in, or both left empty.",
    "hqblog.err.slugRequired": "The slug is required.",
    "hqblog.cover": "Cover image",
    "plans.image": "Plan image",
    "cat.boosterImage": "Booster image",
  },
  es: {
    "hsite.title": "Sitio Solunary",
    "hsite.subtitle": "Todo lo que dice, muestra y enlaza la página de inicio pública. Cada cambio guardado se publica al instante.",
    "hsite.tab.content": "Contenido",
    "hsite.tab.media": "Medios",
    "hsite.tab.links": "Enlaces",
    "hsite.retry": "Reintentar",

    "hsite.section.navbar": "Encabezado",
    "hsite.section.hero": "Hero",
    "hsite.section.dualpillar": "Dos pilares",
    "hsite.section.ecosystem": "Ecosistema",
    "hsite.section.pricing": "Precios",
    "hsite.section.turnkey": "Llave en mano y migración",
    "hsite.section.boosters": "Boosters y comisiones",
    "hsite.section.faq": "Preguntas frecuentes",
    "hsite.section.finalCta": "Llamada final",
    "hsite.section.footer": "Pie de página",
    "hsite.locale.fr": "Francés",
    "hsite.locale.en": "Inglés",
    "hsite.locale.es": "Español",

    "hsite.content.hint": "Deja un idioma vacío para conservar el texto predeterminado (en gris). Un cambio en un idioma solo lo ven los visitantes de ese idioma.",
    "hsite.content.sections": "Secciones de la página",
    "hsite.content.vars": "Variables:",
    "hsite.content.overridden": "Modificado",
    "hsite.content.default": "Predeterminado",
    "hsite.content.save": "Guardar",
    "hsite.content.saved": "Guardado — publicado",
    "hsite.content.reset": "Restablecer",
    "hsite.content.resetDone": "Texto predeterminado restablecido",
    "hsite.content.tooLong": "{locale}: {max} caracteres como máximo.",
    "hsite.content.undeclared": "{locale}: {placeholders} no es una variable de este campo.",
    "hsite.content.imageDefault": "Imagen predeterminada del sitio",
    "hsite.content.imageChosen": "Imagen elegida de la mediateca",

    "hsite.media.hint": "Las imágenes de la página de inicio, el blog, los planes y los boosters. Una imagen en uso no se puede eliminar.",
    "hsite.media.upload": "Subir una imagen",
    "hsite.media.uploading": "Subiendo…",
    "hsite.media.uploaded": "Imagen añadida",
    "hsite.media.rules": "{types} · {max} como máximo",
    "hsite.media.wrongType": "Formato rechazado. Formatos aceptados: {types}.",
    "hsite.media.tooBig": "Archivo demasiado grande: {max} como máximo.",
    "hsite.media.empty": "Todavía no hay imágenes.",
    "hsite.media.alt": "Texto alternativo {locale}",
    "hsite.media.altTooLong": "Texto alternativo: {max} caracteres como máximo.",
    "hsite.media.saveAlt": "Guardar",
    "hsite.media.altSaved": "Texto alternativo guardado",
    "hsite.media.usage": "Dónde se usa",
    "hsite.media.unused": "No se usa en ninguna parte.",
    "hsite.media.delete": "Eliminar",
    "hsite.media.confirmDelete": "Confirmar eliminación",
    "hsite.media.deleted": "Imagen eliminada",
    "hsite.media.ref.content_block": "Página de inicio",
    "hsite.media.ref.blog_post": "Artículo del blog",
    "hsite.media.ref.plan": "Plan",
    "hsite.media.ref.booster": "Booster",

    "hsite.picker.title": "Mediateca",
    "hsite.picker.description": "Elige una imagen o sube una nueva.",
    "hsite.picker.empty": "La mediateca está vacía — sube una imagen.",
    "hsite.picker.choose": "Elegir {name}",
    "hsite.picker.chooseImage": "Elegir una imagen",
    "hsite.picker.replace": "Reemplazar",
    "hsite.picker.remove": "Quitar la imagen",

    "hsite.links.hint": "El encabezado y el pie de página del sitio muestran exactamente estos enlaces, en este orden. Un grupo del pie de página vacío no se muestra.",
    "hsite.links.header": "Encabezado",
    "hsite.links.footer": "Pie de página",
    "hsite.links.footerGroup": "Pie de página — {group}",
    "hsite.links.group.product": "Producto",
    "hsite.links.group.company": "Empresa",
    "hsite.links.group.legal": "Legal",
    "hsite.links.add": "Añadir un enlace",
    "hsite.links.empty": "Sin enlaces.",
    "hsite.links.label": "Etiqueta {locale}",
    "hsite.links.hrefLabel": "Destino",
    "hsite.links.hrefPlaceholder": "#pricing, /marketplace, https://…, mailto:…",
    "hsite.links.href.help": "Una sección de la página (#…), una página del sitio (/…), una dirección https:// o mailto:.",
    "hsite.links.href.tooLong": "{max} caracteres como máximo.",
    "hsite.links.href.unknownAnchor": "Esa sección no existe en la página. Secciones: {anchors}.",
    "hsite.links.href.invalid": "Destino rechazado: usa #sección, /página, https://… o mailto:….",
    "hsite.links.newTab": "Abrir en una pestaña nueva",
    "hsite.links.location": "Ubicación",
    "hsite.links.groupLabel": "Grupo",
    "hsite.links.save": "Guardar",
    "hsite.links.cancel": "Cancelar",
    "hsite.links.created": "Enlace añadido",
    "hsite.links.updated": "Enlace modificado",
    "hsite.links.deleted": "Enlace eliminado",
    "hsite.links.edit": "Editar {label}",
    "hsite.links.delete": "Eliminar {label}",
    "hsite.links.confirmDelete": "Confirmar la eliminación de {label}",
    "hsite.links.confirmDeleteShort": "Confirmar",
    "hsite.links.moveUp": "Subir {label}",
    "hsite.links.moveDown": "Bajar {label}",

    "hsite.err.generic": "No se pudo guardar. Inténtalo de nuevo.",
    "hsite.err.unknownKey": "El campo {key} ya no existe. Recarga la página.",
    "hsite.err.wrongKind": "El campo {key} no acepta este tipo de contenido.",
    "hsite.err.undeclaredPlaceholder": "{locale}: {placeholders} no es una variable de este campo. Variables permitidas: {allowed}.",
    "hsite.err.noPlaceholderAllowed": "ninguna",
    "hsite.err.tooLong": "{locale}: {max} caracteres como máximo.",
    "hsite.err.unknownMedia": "Esa imagen ya no está en la mediateca. Elige otra.",
    "hsite.err.invalidHref": "Destino rechazado: {href}",
    "hsite.err.invalidLinkGroup": "Elige un grupo para un enlace del pie de página (y ninguno para el encabezado).",
    "hsite.err.linkNotFound": "Ese enlace ya no existe. Recarga la página.",
    "hsite.err.mediaNotFound": "Esa imagen ya no existe. Recarga la página.",
    "hsite.err.mediaInUse": "Imagen usada en {count} lugar(es): quítala de ahí primero.",
    "hsite.err.unsupportedMediaType": "Este archivo no es una imagen aceptada (PNG, JPEG, WEBP o GIF).",
    "hsite.err.mediaTooLarge": "Archivo demasiado grande: {max} como máximo.",
    "hsite.err.mediaTooLargeNoMax": "Archivo demasiado grande.",
    "hsite.err.reorderMismatch": "Los enlaces cambiaron mientras tanto. Recarga la página e inténtalo de nuevo.",

    "hqblog.title": "Blog",
    "hqblog.subtitle": "Artículos publicados en el blog de Solunary.",
    "hqblog.new": "Nuevo artículo",
    "hqblog.colTitle": "Título",
    "hqblog.colLanguages": "Idiomas",
    "hqblog.colStatus": "Estado",
    "hqblog.colPublished": "Publicado",
    "hqblog.colUpdated": "Modificado",
    "hqblog.published": "publicado",
    "hqblog.draft": "borrador",
    "hqblog.never": "—",
    "hqblog.empty": "Ningún artículo.",
    "hqblog.confirmDelete": "¿Eliminar este artículo?",
    "hqblog.saved": "Guardado",
    "hqblog.error": "Error",
    "hqblog.retry": "Reintentar",
    "hqblog.editTitle": "Editar artículo",
    "hqblog.newTitle": "Nuevo artículo",
    "hqblog.search": "Buscar (título o slug)",
    "hqblog.filterStatus": "Filtrar por estado",
    "hqblog.statusAll": "Todos",
    "hqblog.statusPublished": "Publicados",
    "hqblog.statusDraft": "Borradores",
    "hqblog.sortBy": "Ordenar por",
    "hqblog.sortUpdated": "Última modificación",
    "hqblog.sortPublished": "Fecha de publicación",
    "hqblog.sortCreated": "Fecha de creación",
    "hqblog.total": "{total} artículo(s)",
    "hqblog.pagerInfo": "{from}–{to} de {total}",
    "hqblog.pagerPrev": "Anterior",
    "hqblog.pagerNext": "Siguiente",
    "hqblog.edit": "Editar",
    "hqblog.preview": "Vista previa",
    "hqblog.openPublic": "Abrir la página pública",
    "hqblog.delete": "Eliminar",
    "hqblog.close": "Cerrar",
    "hqblog.write": "Escribir",
    "hqblog.lang.fr": "Francés",
    "hqblog.lang.en": "Inglés",
    "hqblog.lang.es": "Español",
    "hqblog.fTitle": "Título",
    "hqblog.fExcerpt": "Extracto",
    "hqblog.fTag": "Tag",
    "hqblog.fBody": "Contenido (Markdown)",
    "hqblog.fSlug": "Slug (dirección del artículo)",
    "hqblog.fPublished": "Publicado",
    "hqblog.excerptHint": "También se usa como descripción al compartir el enlace.",
    "hqblog.bodyHint": "Markdown: # título, **negrita**, *cursiva*, [enlace](https://…), listas con - o 1.",
    "hqblog.slugHint": "Minúsculas, dígitos y guiones. Se sugiere a partir del primer título.",
    "hqblog.savecta": "Guardar",
    "hqblog.err.slugTaken": "Este slug ya lo usa otro artículo.",
    "hqblog.err.noLanguage": "Rellena al menos un idioma (título y contenido).",
    "hqblog.err.notFound": "Artículo no encontrado.",
    // the per-field line of a FastAPI 422 list (lib/apiErrors.js asks for this key on the `t` it is given)
    "errors.invalidFieldValue": "Valor inválido",
    "hqblog.err.languageIncomplete": "{lang}: el título y el contenido deben estar ambos rellenos, o ambos vacíos.",
    "hqblog.err.slugRequired": "El slug es obligatorio.",
    "hqblog.cover": "Imagen de portada",
    "plans.image": "Imagen del plan",
    "cat.boosterImage": "Imagen del booster",
  },
};
